export default __webpack_public_path__ + "static/media/42.3f58ec78.png";